<!-- Content -->
<div class="quoter-content" [class.quoter-content--locked]="disabled">
  <div class="quoter-main-section">
    <!-- Currency Cards -->
    <div class="quoter-currency-cards">
      <!-- From Currency Card -->
      <div class="quoter-currency-card">
        <h3 class="quoter-card-title">{{ 'QUOTER.HAVE_CURRENCY_TITLE' | translate }}</h3>
        <div class="quoter-card-body">
          <div class="quoter-currency-selector">
            <div class="quoter-flag-wrapper">
              <img
                *ngIf="queDivisaTienes?.currency?.logoUrl"
                [src]="queDivisaTienes.currency.logoUrl"
                [alt]="queDivisaTienes.currency.code | currencyName : queDivisaTienes.currency.name"
                class="quoter-flag"
              />
              <mat-icon *ngIf="!queDivisaTienes?.currency?.logoUrl"
                class="quoter-flag-icon" svgIcon="currency_exchange"></mat-icon>
              <span class="quoter-currency-code">{{
                queDivisaTienes.currency.code
              }}</span>
            </div>
            <div
              class="quoter-dropdown-button"
              *ngIf="!promoLocked"
              [matMenuTriggerFor]="fromCurrencyMenu"
            >
              <mat-icon svgIcon="keyboard_arrow_down"></mat-icon>
            </div>
          </div>
          <div class="quoter-amount-input-wrapper">
            <mat-form-field class="quoter-amount-form-field">
              <mat-label class="quoter-currency-label">{{
                queDivisaTienes.currency.code | currencyName : queDivisaTienes.currency.name
              }}</mat-label>
              <mat-select
                *ngIf="isFromCen"
                class="quoter-amount-field"
                [(ngModel)]="fromAmount"
                (ngModelChange)="onAmountChange('from')"
              >
                <mat-option *ngFor="let n of cenOptions" [value]="n">{{
                  n
                }}</mat-option>
              </mat-select>
              <input
                *ngIf="!isFromCen && !isToCen"
                matInput
                currencyMask
                class="quoter-amount-field"
                [(ngModel)]="fromAmount"
                (ngModelChange)="onAmountChange('from')"
                (blur)="onAmountChange('from')"
              />
              <input
                *ngIf="!isFromCen && isToCen"
                matInput
                class="quoter-amount-field quoter-amount-field--readonly"
                [value]="fromAmount | number : '1.2-2'"
                readonly
              />
            </mat-form-field>
          </div>
        </div>
        <mat-menu #fromCurrencyMenu="matMenu" class="quoter-currency-menu">
          <button
            mat-menu-item
            *ngFor="let currency of availableFrom"
            (click)="onChangeCurrency(currency, 'from')"
            [class.quoter-menu-item-selected]="
              currency.id === queDivisaTienes.id
            "
          >
            {{ currency.currency.code | currencyName : currency.currency.name }}
          </button>
        </mat-menu>
      </div>

      <!-- Swap Button -->
      <div class="quoter-swap-button-wrapper" *ngIf="!promoLocked">
        <button
          class="quoter-swap-button"
          (click)="onSwapCurrencies()"
          [attr.aria-label]="'QUOTER.SWAP_ARIA_LABEL' | translate"
        >
          <mat-icon svgIcon="cached"></mat-icon>
        </button>
      </div>

      <!-- To Currency Card -->
      <div class="quoter-currency-card">
        <h3 class="quoter-card-title">{{ 'QUOTER.WANT_CURRENCY_TITLE' | translate }}</h3>
        <div class="quoter-card-body">
          <div class="quoter-currency-selector">
            <div class="quoter-flag-wrapper">
              <img
                *ngIf="queDivisaQuieres?.currency?.logoUrl"
                [src]="queDivisaQuieres.currency.logoUrl"
                [alt]="queDivisaQuieres.currency.code | currencyName : queDivisaQuieres.currency.name"
                class="quoter-flag"
              />
              <mat-icon *ngIf="!queDivisaQuieres?.currency?.logoUrl"
                class="quoter-flag-icon" svgIcon="currency_exchange"></mat-icon>
              <span class="quoter-currency-code">{{
                queDivisaQuieres.currency.code
              }}</span>
            </div>
            <div
              class="quoter-dropdown-button"
              *ngIf="!promoLocked"
              [matMenuTriggerFor]="toCurrencyMenu"
            >
              <mat-icon svgIcon="keyboard_arrow_down"></mat-icon>
            </div>
          </div>
          <div class="quoter-amount-input-wrapper">
            <mat-form-field class="quoter-amount-form-field">
              <mat-label class="quoter-currency-label">{{
                queDivisaQuieres.currency.code | currencyName : queDivisaQuieres.currency.name
              }}</mat-label>
              <mat-select
                *ngIf="isToCen"
                class="quoter-amount-field"
                [(ngModel)]="toAmount"
                (ngModelChange)="onAmountChange('to')"
              >
                <mat-option *ngFor="let n of cenOptions" [value]="n">{{
                  n
                }}</mat-option>
              </mat-select>
              <input
                *ngIf="!isToCen && !isFromCen"
                matInput
                currencyMask
                class="quoter-amount-field"
                [(ngModel)]="toAmount"
                (ngModelChange)="onAmountChange('to')"
                (blur)="onAmountChange('to')"
              />
              <input
                *ngIf="!isToCen && isFromCen"
                matInput
                class="quoter-amount-field quoter-amount-field--readonly"
                [value]="toAmount | number : '1.2-2'"
                readonly
              />
            </mat-form-field>
          </div>
        </div>
        <mat-menu #toCurrencyMenu="matMenu" class="quoter-currency-menu">
          <button
            mat-menu-item
            *ngFor="let currency of availableTo"
            (click)="onChangeCurrency(currency, 'to')"
            [class.quoter-menu-item-selected]="
              currency.id === queDivisaQuieres.id
            "
          >
            {{ currency.currency.code | currencyName : currency.currency.name }}
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
</div>
